<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize"> {{ $t("maintenance.template_name") }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="templateFilter"
          :options="templateOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:templateFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("maintenance.serviceOrder")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="serviceOrderFilter"
          :options="serviceOrderOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:serviceOrderFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("maintenance.status.latest_status")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="serviceOrdersStatusFilter"
          :options="serviceOrdersStatusOptions"
          class="w-100"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:serviceOrdersStatusFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{
          $t("unit.single")
        }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          :reduce="(val) => val.value"
          multiple
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
  },
  props: {
    serviceOrderOptions: {
      type: Array,
      default: null,
    },
    serviceOrderFilter: {
      type: Array,
      default: null,
    },
    templateOptions: {
      type: Array,
      default: null,
    },
    templateFilter: {
      type: Array,
      default: null,
    },
    serviceOrdersStatusOptions: {
      type: Array,
      default: null
    },
    serviceOrdersStatusFilter: {
      type: Number,
      default: null,
    },
    unitOptions: {
      type: Array,
      default: null,
    },
    unitFilter: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
